/**
 * SLTSnowAppErrCodes
 *      these are error codes specific to the SLT Snow application (not SLT Snow REST APIs)
 */
module.exports = {
    SLTSnowAppErrCodes: {
        APPERR_UNKNOWN : 100000,
        APPERR_MISSINGPARAM : 100001,
        APPERR_PROPSMISSING : 100008,
        APPERR_PASSKEY_NOT_REGISTERED : 20064,
    }
}